import React from 'react';
import { Card } from 'antd';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

const statusPercentage =[
        { name: 'Open', value: 40 },
        { name: 'Closed', value: 30 },
        { name: 'Pending', value: 20 },
        { name: 'Resolved', value: 10 },
];
const TicketsByStatus: React.FC = () => { 
   return (
     <Card title="Tickets by Status in Percentage" className="chart-half">
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie 
                    data={statusPercentage} 
                    dataKey="value" 
                    nameKey="name" 
                    outerRadius={120} 
                    fill="#8884d8"
                  >
                    {statusPercentage.map((entry, index) => (
                      <Cell 
                        key={`cell-${index}`} 
                        fill={["#FF8042", "#0088FE", "#00C49F", "#FFBB28"][index % 4]} 
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </Card>
);};
export default TicketsByStatus;